<template>
  <basic-container>

    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="{ row }" slot="status">
        <el-tag
          style="
            font-size: 14px;
            width: 76px;
            height: 32px;
            line-height: 32px;
            text-align: center;
          "
          :type="row.status === 0 ? 'danger' : 'success'"
        >
          {{ row.status === 0 ? "未启用" : "已启用" }}</el-tag
        >
      </template>
      <template slot-scope="scope" slot="approveTypeForm">

        <!-- clearable -->
        <el-select
          v-model="form.approveType"
          @change="approveTypeChange"
          ref="approveType"
        >
          <el-option
            v-for="(item, index) in orderApproveTypeList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>

        <!-- <el-button @click="clearUserIdsInput">清空</el-button> -->
      </template>
      <template slot-scope="scope" slot="userIdsForm">
        <el-input
          readonly
          v-model="form.userIds"
           placeholder="请选择 审批人员"
          ref="formUserIds"
          style="display: none"
        ></el-input>
        <el-input
          @focus="addUserBox"
          ref="formUserNames"
          placeholder="请选择 审批人员"
          v-model="formUserNames"
          clearable
          @clear="clearHandler"
          :disabled="!isNeedPeople"
        ></el-input>

      </template>
      <template slot-scope="scope" slot="notifyFlagForm">
        <el-radio-group v-model="form.notifyFlag" @change="changeNotifyFlag">
          <el-radio :label="0">不通知</el-radio>
          <el-radio :label="1">通知</el-radio>
        </el-radio-group>
      </template>
      <template slot-scope="scope" slot="orderNotifyTargetsForm">
        <el-select
          v-model="form.orderNotifyTargets"
          @change="orderNotifyTargetsChange"
          ref="orderNotifyTargets"
          placeholder="请选择 通知对象"
          multiple
          :disabled="form.notifyFlag == 0"
        >
          <el-option
            v-for="(item, index) in orderNotifyTargetsList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>

      </template>
      <template slot-scope="scope" slot="orderNotifyIdsForm">
        <el-select
          v-model="form.orderNotifyIds"
          ref="orderNotifyIds"
          multiple
          placeholder="请选择 通知人"
          :disabled="
            form.notifyFlag == 0 ||
            !form.orderNotifyTargets.includes('4')
          "
        ></el-select>
        <el-input
          readonly
          v-model="form.orderNotifyIds"
          placeholder="请选择 通知人员"
          ref="formOrderNotifyIds"
          style="display: none"
        ></el-input>
        <el-input
          @focus="addNotifyUserBox"
          ref="formNotifyUserNames"
          placeholder="请选择 通知人员"
          v-model="formNotifyUserNames"
          clearable
          @clear="clearNotifyUserHandler"
          :disabled="form.notifyFlag == 0 ||
            !form.orderNotifyTargets.includes('4')"
        ></el-input>
      </template>

      <template slot-scope="scope" slot="systemNotifyWaysForm">
        <el-select
          v-model="form.systemNotifyWays"
          ref="systemNotifyWays"
          placeholder="请选择 通知方式"
          multiple
          :disabled="form.notifyFlag == 0"
        >
          <el-option
            v-for="(item, index) in systemNotifyWaysList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          ></el-option>
        </el-select>
      </template>

      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.ordersettingaction_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="permissionList.useBtn"
          icon="el-icon-edit-outline"
          @click.native="changeStatus(scope.row)"
        >{{ getLabelName(scope.row.status) }}
        </el-button>
        <!-- <el-button
          type="text"
          size="small"
          v-if="permissionList.templateBtn"
          icon="el-icon-s-comment"
          @click.native="openRemarkTemplateDialog(scope.row)"
          >备注模板
        </el-button> -->
      </template>
    </avue-crud>

    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :remainUserListInside="remainUserList"
        :projectId="tempProjectId"
      />
    </el-dialog>

    <hr-dialog
     id="templateListDialog"
     title="备注模板"
     width="50%"
     :visible.sync="dialogRemarkTemplateVisible"
    >
      <template slot="body">
        <remark-template
        v-if="dialogRemarkTemplateVisible"
        :actionRow="actionRow"
        :projectId="projectId"
        :componentRow="componentRow"
      />
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  availableActionList,
  getDictionary,
  updateStatus,
} from "@/api/v4ward/gateservice/ordersetting/action/ordersettingaction";
import { mapGetters } from "vuex";
import userEditBox from "@/views/crmedical/group/user-edit-box";
import { getUserListByDepartmentId } from "@/api/crmedical/group/group";
import remarkTemplate from "@/views/v4ward/ordersetting/action/order-remark-template";
import { setTimeout } from 'timers';

export default {
  props: ["flowid", "projectId", "componentRow"],
  components: {
    userEditBox,
    remarkTemplate,
  },
  data() {
    var validateSortNoPass = (rule, value, callback) => {
      let re = /^[0-9]+$/;
      if (value === "") {
        callback(new Error("请输入排序！"));
      } else if (!re.test(value)) {
        callback(new Error("排序格式错误!"));
      } else {
        callback();
      }
    };
    return {
      groupNotyfyFlag: false,
      isNeedPeople: false,
      orderNotifyTargetsList: [],
      orderNotifyIdsList: [],
      systemNotifyWaysList: [],
      orderApproveTypeList: [],
      remainUserList: [],
      userList: [],
      notifyUserList: [],
      selectUserDialogType:"",
      actionRow: {},
      formUserNames: "",
      formNotifyUserNames: "",
      tempFormUserNames: "",
      tempFormUserIds: "",
      handleAction: "",
      selectUserType: "",
      tempProjectId: "",
      dialogUserEditBoxVisible: false,
      dialogRemarkTemplateVisible: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        columnBtn: true,
        refreshBtn: false,
        indexLabel: "序号",
        align: "left",
        dialogWidth: '50%',
        addBtn:false,
        delBtn:false,
        column: [
          {
            label: "工单状态",
            prop: "workStatus",
            editDisabled: true,
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=out_order_work_status",
            search: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            rules: [
              {
                required: true,
                message: "请选择工单状态",
                trigger: "change",
              },
            ],
          },
          {
            label: "工单操作",
            prop: "actionType1",
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=out_order_action",
            search: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            hide: true,
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
          },
          {
            label: "工单操作",
            prop: "actionTypeName",
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
          },
          {
            label: "工单操作",
            prop: "actionType",
            type: "select",
            hide: true,
            dicData: [],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择工单操作",
                trigger: "change",
              },
            ],
          },
          {
            label: "审批设置",
            prop: "approveType",
            type: "select",
            dataType: "number",
            dicUrl: "/api/blade-system/dict/dictionary?code=order_approve_type",
            search: true,
            formslot: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择审批设置",
                trigger: "change",
              },
            ],
          },
          {
            label: "审批人员",
            prop: "userIds",
            formslot: true,
            hide: true,
          },
          {
            label: "是否通知",
            prop: "notifyFlag",
            formslot: true,
            hide: true,
          },
          {
            label: "通知对象",
            prop: "orderNotifyTargets",
            formslot: true,
            hide: true,
          },
          {
            label: "通知人",
            prop: "orderNotifyIds",
            formslot: true,
            hide: true,
          },
          {
            label: "通知方式",
            prop: "systemNotifyWays",
            formslot: true,
            hide: true,
          },
          {
            label: "排序",
            prop: "sortNo",
            type: "input",
            maxlength: "4",
            placeholder: "请输入 排序",
            rules: [
              {
                required: true,
                // message: "请输入排序",
                validator: validateSortNoPass,
                trigger: "change",
              },
            ],
          },
          {
            label: "状态",
            prop: "status",
            addDisplay: false,
            editDisabled: true,
            width: 100,
            value: 0,
            type: "select",
            slot: true,
            dicData: [
              { label: "未启用", value: 0 },
              { label: "已启用", value: 1 },
            ],
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "change",
              },
            ],
          },
          {
            label: "描述",
            prop: "description",
            overHidden: true,
            placeholder: "请输入 描述",
            maxlength: 50,
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    "form.workStatus"(val) {
      console.log("form.workStatus==>", val);
      this.initActionTypeList();
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.ordersettingaction_add, true),
        viewBtn: this.vaildData(this.permission.ordersettingaction_view, false),
        delBtn: this.vaildData(this.permission.ordersettingaction_delete, true),
        editBtn: this.vaildData(this.permission.ordersettingaction_edit, true),
        templateBtn: this.vaildData(this.permission.marktemplate, true),
        useBtn: this.vaildData(this.permission.ordersetting_use, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  mounted(){
    this.setAvueCrudHeight()
  },
  created() {

    getDictionary({ code: "out_order_notify_target" }).then((res) => {
      this.orderNotifyTargetsList = res.data;
    });
    getDictionary({ code: "order_approve_type" }).then((res) => {
      this.orderApproveTypeList = res.data;
    });
    // /api/blade-system/dict/dictionary?code=
    getDictionary({ code: "system_notify_way" }).then((res) => {
      this.systemNotifyWaysList = res.data;
    });
  },
  methods: {
    setAvueCrudHeight(){
      this.option.height = this.bodyHeight  - 379;
      // this.$nextTick(() => {

      //         setTimeout(()=>{
      //         console.log(this.$refs.crud)
      //         this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{
      //           this.isClickSearch = !this.isClickSearch
      //           console.log(1212121)
      //               if(this.isClickSearch){
      //                 this.option.height = this.bodyHeight - 340
      //               }else{
      //                 this.option.height = this.bodyHeight - 280;
      //               }
      //               this.$refs.crud.getTableHeight();
      //           });
      //         })
      //       });
    },
    changeStatus(row) {
      let status = row.status === 1 ? 0 : 1;
      let label = "确认停用此组件?";
      if (status === 1) {
        label = "确认启用此组件?";
      }
      this.$confirm(label, {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      }).then(() => {
        // eslint-disable-next-line no-unused-vars
        updateStatus(row).then((res) => {
          row.status = status;
          this.$message.success("操作成功!");
        });
      });
    },
    getLabelName(status) {
      if (status === 1) {
        return "停用";
      } else {
        return "启用";
      }
    },
    approveTypeChange(val) {
      console.log("val", val);
      if (val == 1) {
        this.isNeedPeople = false;
        //
        setTimeout(() => {
          this.formUserNames = "";
          this.form.userIds = "";
          this.userList = [];
        });
      } else {
        this.isNeedPeople = true;
      }
    },
    orderNotifyTargetsChange(val) {
      setTimeout(() => {
        if (!this.form.orderNotifyTargets.includes("4")) {
          this.notifyUserNames = "";
          this.form.orderNotifyIds = "";
        }
      });
    },
    changeNotifyFlag(val) {
      console.log(val);
      this.form.systemNotifyWays = "";
      this.form.orderNotifyTargets = "";
      this.form.orderNotifyIds = "";
      this.formNotifyUserNames = "";
      this.notifyUserList = [];
    },
    clearHandler(e) {
      this.form.userIds = "";
      this.formUserNames = "";
      this.remainUserList = [];
      this.userList = [];
    },
    clearNotifyUserHandler(e) {
      this.form.orderNotifyIds = "";
      this.formNotifyUserNames = "";
      this.remainUserList = [];
      this.notifyUserList = [];
    },
    openRemarkTemplateDialog(row) {
      console.log(row);
      this.actionRow = row;
      this.dialogRemarkTemplateVisible = true;
    },
    handleSubmitAction(val) {
      if(this.selectUserDialogType==1){
        this.formUserNames = val.nameListString;
        this.form.userIds = val.idListString;
        this.userList = val.dataSelectedUsers;
      }else{
        this.formNotifyUserNames = val.nameListString;
        this.form.orderNotifyIds = val.idListString;
        this.notifyUserList = val.dataSelectedUsers;
      }
      this.dialogUserEditBoxVisible = false;
    },
    handleCloseAction(val) {
      this.selectUserDialogType = "";
      this.remainUserList = [];
      this.dialogUserEditBoxVisible = false;
    },
    addUserBox() {
      this.tempProjectId = this.projectId;
      this.selectUserDialogType = 1;
      this.handleAction = 1;
      this.selectUserType = 1;
      this.remainUserList = this.userList;
      this.dialogUserEditBoxVisible = true;

    },
    addNotifyUserBox() {
      this.tempProjectId = this.projectId;
      this.selectUserDialogType = 2;
      this.handleAction = 1;
      this.selectUserType = 1;
      this.remainUserList = this.notifyUserList;
      this.dialogUserEditBoxVisible = true;
    },
    initActionTypeList() {
      let workStatus = this.form.workStatus;
      if (this.vdui.isNotEmpty(workStatus)) {
        availableActionList({ workStatus: workStatus }).then((res) => {
          var actionTypeColumn = this.findObject(
            this.option.column,
            "actionType"
          );
          actionTypeColumn.dicData = res.data;
          if (!this.checkIncludeType(this.form.actionType, res.data)) {
            this.form.actionType = "";
          }
          if (res.data.length === 0) {
            actionTypeColumn.dicData = [{}];
            this.$message.warning("当前工单状态下没有可操作的动作！");
          }
        });
      }
    },
    checkIncludeType(value, listData) {
      if (listData.length === 0) {
        return false;
      }
      if (this.vdui.isNotEmpty(value)) {
        let filterOne = listData.filter((d) => {
          return d.dictKey === value;
        });
        return filterOne.length > 0;
      }
      return false;
    },
    rowSave(row, done, loading) {
      console.log(row);
      let addForm = "";
      addForm = this.deepClone(row);
      if (addForm.notifyFlag == 1) {
        if (
          !addForm.orderNotifyTargets ||
          addForm.orderNotifyTargets.length == 0
        ) {
          this.$message.warning('请选择"通知对象"');
          // done();
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // loading();
          return;
        }

        if (!addForm.systemNotifyWays || addForm.systemNotifyWays.length == 0) {
          this.$message.warning('请选择"通知方式"');
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // done();
          // loading();
          return;
        }

        if (
          addForm.orderNotifyTargets.includes("4") &&
          (!addForm.orderNotifyIds || addForm.orderNotifyIds.length == 0)
        ) {
          this.$message.warning('请选择"通知人员"');
          // done();
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // loading();
          return;
        }
        addForm.orderNotifyTargets = addForm.orderNotifyTargets.join(",");
        addForm.systemNotifyWays = addForm.systemNotifyWays.join(",");
      }
      if (!addForm.orderNotifyIds || addForm.orderNotifyIds.length == 0) {
        addForm.orderNotifyIds = "";
      }
      if (
        !addForm.orderNotifyTargets ||
        addForm.orderNotifyTargets.length == 0
      ) {
        addForm.orderNotifyTargets = "";
      }
      if (!addForm.systemNotifyWays || addForm.systemNotifyWays.length == 0) {
        addForm.systemNotifyWays = "";
      }


      // return;
      addForm.settingId = this.flowid;
      add(addForm).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      console.log("row update==>");
      let editForm = "";
      editForm = this.deepClone(row);
      editForm.orderNotifyIds = this.form.orderNotifyIds;
      editForm.orderNotifyTargets = this.form.orderNotifyTargets;
      console.log(editForm);
      if (editForm.notifyFlag == 1) {
        if (
          !editForm.orderNotifyTargets ||
          editForm.orderNotifyTargets.length == 0
        ) {
          this.$message.warning('请选择"通知对象"');
          // done();
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // loading();
          return;
        }

        if (
          !editForm.systemNotifyWays ||
          editForm.systemNotifyWays.length == 0
        ) {
          this.$message.warning('请选择"通知方式"');
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // done();
          // loading();
          return;
        }

        if (
          editForm.orderNotifyTargets.includes("4") &&
          (!editForm.orderNotifyIds ||
            editForm.orderNotifyIds.length == 0)
        ) {
          this.$message.warning('请选择"通知人员"');
          // done();
          setTimeout(() => {
            // this.$message.success('关闭按钮等待');
            loading();
          }, 100);
          // loading();
          return;
        }
        editForm.orderNotifyTargets = editForm.orderNotifyTargets.join(",");
        editForm.systemNotifyWays = editForm.systemNotifyWays.join(",");
      }

      if (
        !editForm.orderNotifyIds ||
        editForm.orderNotifyIds.length == 0
      ) {
        editForm.orderNotifyIds = "";
      }
      if (
        !editForm.orderNotifyTargets ||
        editForm.orderNotifyTargets.length == 0
      ) {
        editForm.orderNotifyTargets = "";
      }
      if (!editForm.systemNotifyWays || editForm.systemNotifyWays.length == 0) {
        editForm.systemNotifyWays = "";
      }

      if (!editForm.systemNotifyWays || editForm.systemNotifyWays.length == 0) {
        editForm.systemNotifyWays = "";
      }
      console.log(editForm);
      update(editForm).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    setUiStandard(){
        let dom = this.$refs.crud.$children[4].$children[0].$refs.dialog
      dom.className+=" lhrodersetting01"
      dom.id = 'lhrodersetting01'
      console.log("***ee",this.$refs.crud.$children[4].$children[0].customClass)
        console.log("***dd",this.$refs.crud.$children[4].$children[0])
    },
    beforeOpen(done, type) {
     this.setUiStandard()
      this.formUserNames = "";
      this.formNotifyUserNames = "";
      this.userList = [];
      this.notifyUserList = [];
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = this.deepClone(data);
          this.formUserNames = data.userNames;
          this.formNotifyUserNames = data.notifyUserNames;
          this.userList = data.userList;
          this.notifyUserList = data.notifyUserList;
          if (this.form.approveType) {
            this.form.approveType = this.form.approveType + "";
            //判断状态
            if (this.form.approveType == 1) {
              this.isNeedPeople = false;
            }
            if (this.form.approveType == 4) {
              this.isNeedPeople = true;
            }
          }
          if (this.form.orderNotifyTargets) {
            this.form.orderNotifyTargets = this.form.orderNotifyTargets.split(
              ","
            );
          }
          if (this.form.systemNotifyWays) {
            this.form.systemNotifyWays = this.form.systemNotifyWays.split(",");
          }
        });
      }
      if (["add"].includes(type)) {
        console.log("add====>this.form.notifyFlag");
        this.formUserNames = "";
        this.formNotifyUserNames = "";
        this.form = Object.assign({}, this.form, { notifyFlag: 0 });
        console.log("add====>this.form", this.form);
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isEmpty(this.flowid)) {
        console.log("flowid为空！");
        return;
      }
      this.query.settingId = this.flowid;
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style>
div[id="templateListDialog"] .el-dialog__body {
  padding-top: 0;
}
#lhrodersetting01 .el-dialog__body{

  padding-right: 24px !important;
}
/* #lhrodersetting01 .el-form-item.el-form-item--small:last-child .el-form-item__content {
  background: yellow;
} */
</style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
::v-deep .el-table--small{
  height: 630px!important;
}
::v-deep .avue-crud__pagination{
  padding-bottom:0!important;
}
::v-deep .el-table .cell{
  line-height: 60px!important;
}
</style>
